"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _GeopointBase = _interopRequireDefault(require("./GeopointBase"));

var _GeopointMap = _interopRequireDefault(require("./GeopointMap"));

var _GeopointMapCenter = _interopRequireDefault(require("./GeopointMapCenter"));

var _GeopointSearch = _interopRequireDefault(require("./GeopointSearch"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  geocoder: {
    backgroundColor: "#e5e3df",
    width: "100%",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  search: {
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    bottom: "auto",
    left: 0,
    margin: theme.spacing(2)
  }
}));

const Geocoder = ({
  googleMapsApiKey,
  location,
  onChange
}) => {
  const lat = location.lat,
        lng = location.lng,
        zoom = location.zoom;

  const handleChange = location => {
    onChange && onChange(location);
  };

  const handleMapChange = map => {
    console.log('map', map);
    let lat, lng;

    if (map && map.center) {
      lat = map.center.lat();
      lng = map.center.lng();
    }

    const zoom = map && map.zoom;

    if (lat && lng) {
      handleChange({
        lat: lat,
        lng: lng,
        zoom: zoom
      });
    }
  };

  const handleSearch = place => {
    console.log('place', place);
    let lat, lng;

    if (place && place.geometry && place.geometry.location) {
      lat = place.geometry.location.lat();
      lng = place.geometry.location.lng();
    }

    if (lat && lng) {
      handleChange({
        placeId: place && place.place_id,
        lat: lat,
        lng: lng,
        zoom: zoom
      });
    }
  };

  const classes = useStyles();
  const center = {
    lat: lat,
    lng: lng
  };
  return _react.default.createElement(_GeopointBase.default, {
    className: classes.root,
    googleMapsApiKey: googleMapsApiKey
  }, _react.default.createElement(_GeopointMap.default, {
    center: center,
    zoom: zoom,
    onChange: handleMapChange
  }, _react.default.createElement(_GeopointMapCenter.default, null), _react.default.createElement(_GeopointSearch.default, {
    className: classes.search,
    onChange: handleSearch
  })));
};

Geocoder.defaultProps = {
  googleMapsApiKey: "AIzaSyA0UKwjqalA0BdK5GBh8RPR9HJjtifWLAg",
  location: {
    lat: undefined,
    lng: undefined,
    zoom: undefined
  }
};
var _default = Geocoder;
exports.default = _default;
module.exports = exports.default;